// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1z8Pq","title":"FrontImage_title__xJ5WV"};